import script from "./NewsPageThemesEditPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageThemesEditPopup.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageThemesEditPopup.vue?vue&type=style&index=0&id=751cb790&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751cb790"]])

export default __exports__